import { render, staticRenderFns } from "./bimHeader.vue?vue&type=template&id=63c07447&scoped=true&"
import script from "./bimHeader.vue?vue&type=script&lang=js&"
export * from "./bimHeader.vue?vue&type=script&lang=js&"
import style0 from "./bimHeader.vue?vue&type=style&index=0&id=63c07447&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c07447",
  null
  
)

export default component.exports